// Reservation countdown display authorized by the owner; the internal hold is managed outside this theme.
// Storage survives reload and cart morphs; an expired timer remains at zero.
const storageKey = 'pf_cart_reservation_deadline_v2';
let memoryDeadline;

class PetifoCartTimer extends HTMLElement {
  connectedCallback() {
    if (this.interval) clearInterval(this.interval);
    const duration = Math.max(1, Number(this.dataset.durationSeconds) || 882) * 1000;
    let stored;
    try { stored = Number(sessionStorage.getItem(storageKey)); } catch (_) {}
    this.deadline = Number.isFinite(stored) && stored > 0 ? stored : memoryDeadline;
    if (!this.deadline) {
      this.deadline = Date.now() + duration;
      try { sessionStorage.setItem(storageKey, String(this.deadline)); } catch (_) {}
    }
    memoryDeadline = this.deadline;
    this.output = this.querySelector('[data-pf-timer-time]');
    this.hidden = !this.output;
    if (!this.output) return;
    this.tick();
    if (this.deadline > Date.now()) this.interval = setInterval(() => this.tick(), 1000);
  }

  tick() {
    const seconds = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
    const text = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
    if (this.output.textContent !== text) this.output.textContent = text;
    if (!seconds) {
      clearInterval(this.interval);
      this.interval = null;
      this.dataset.expired = 'true';
    }
  }

  disconnectedCallback() {
    clearInterval(this.interval);
    this.interval = null;
  }
}

if (!customElements.get('pf-cart-timer')) customElements.define('pf-cart-timer', PetifoCartTimer);
